import { FormSelectYesNo } from '../../formelements'

export const AuthImatgeMaterial = ({
  enguany, anyVinent,
  authIntranet, handleChangeIntranet, errorIntranet,
  authPublicacions, handleChangePublicacions, errorPublicacions,
  authInternet, handleChangeInternet, errorInternet,
  authMaterial, handleChangeMaterial, errorMaterial,
  authMaterialNomCognoms, handleChangeMaterialNomCognoms, errorMaterialNomCognoms,
  authMaterialInicials, handleChangeMaterialInicials, errorMaterialInicials,
  authMaterialExposat, handleChangeMaterialExposat, errorMaterialExposat,
  authImatgeProhibicions, handleChangeImatgeProhibicions, errorImatgeProhibicions,
}) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització relativa l'ús d’imatges, publicació de
          dades de caràcter personal i de material
          que elaboren. Curs {enguany}-
          {anyVinent}
        </h4>
        <p>
          El centre disposa d’espais de comunicació
          i difusió, inclosos els espais web (adreça
          o adreces web), on informa i fa difusió de
          les activitats escolars lectives,
          complementàries i extraescolars. En
          aquests espais es poden publicar
          imatges/veu en què aparegui,
          individualment o en grup, alumnat i
          personal docent que fa les activitats
          esmentades. El dret a la pròpia imatge és
          reconegut en l’article 18.1 de la
          Constitució espanyola i està regulat per
          la Llei orgànica 1/1982, de 5 de maig,
          sobre el dret a l’honor, a la intimitat
          personal i familiar i a la pròpia imatge,
          per la qual cosa la direcció d’aquest
          centre demana el consentiment per publicar
          fotografies i vídeos on surti alumnat i
          personal docent que hi sigui clarament
          identificable.
        </p>

        <p>
          Autoritzo mentre mantingui vinculació amb
          el centre
        </p>

        <p>
          1. Que la meva imatge/veu pugui sortir en
          fotografies i/o vídeos corresponents a
          activitats escolars lectives,
          complementàries i extraescolars
          organitzades pel centre i publicades en: -
        </p>
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <FormSelectYesNo
          id="authIntranet"
          name="authIntranet"
          col="col-4"
          label="Filmacions destinades a difusió pública no comercial"
          obligatori={true}
          value={authIntranet}
          handleChange={(e) => handleChangeIntranet(e.target.value)}
          error={errorIntranet}
        />

        <FormSelectYesNo
          id="authPublicacions"
          name="authPublicacions"
          col="col-4"
          label="Revistes o publicacions editades pel centre d’àmbit educatiu"
          obligatori={true}
          value={authPublicacions}
          handleChange={(e) => handleChangePublicacions(e.target.value)}
          error={errorPublicacions}
        />

        <FormSelectYesNo
          id="authInternet"
          name="authInternet"
          col="col-4"
          label="Pàgines web del centre i xarxes socials de l'Escola d'Art La Industrial"
          obligatori={true}
          value={authInternet}
          handleChange={(e) => handleChangeInternet(e.target.value)}
          error={errorInternet}
        />
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <p>
          2.  Que el material elaborat per mi pugui ser publicat en els espais de comunicació del centre
          (web del centre i xarxes socials de l'Escola d'Art La Industrial i revistes editades per aquest) amb
          finalitat de desenvolupar l’activitat educativa
        </p>
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <FormSelectYesNo
          id="authMaterial"
          name="authMaterial"
          col="col-4"
          label="Autoritzo"
          obligatori={true}
          value={authMaterial}
          handleChange={(e) => handleChangeMaterial(e.target.value)}
          error={errorMaterial}
        />
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <p>
          3. Que en les pàgines web i xarxes socials de l'Escola d'Art La Industrial i revistes editades pel centre hi consti el nom del centre i:
        </p>
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <FormSelectYesNo
          id="authMaterialNomCognoms"
          name="authMaterialNomCognoms"
          col="col-4"
          label="El meu nom i cognoms: Autoritzo"
          obligatori={true}
          value={authMaterialNomCognoms}
          handleChange={(e) => handleChangeMaterialNomCognoms(e.target.value)}
          error={errorMaterialNomCognoms}
        />
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <FormSelectYesNo
          id="authMaterialInicials"
          name="authMaterialInicials"
          col="col-4"
          label="Les meves incials: Autoritzo"
          obligatori={true}
          value={authMaterialInicials}
          handleChange={(e) => handleChangeMaterialInicials(e.target.value)}
          error={errorMaterialInicials}
        />
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <p>
          4.  Que el material elaborat per mi pugui ser exposat a l'escola o fora de l'escola amb finalitat de desenvolupar l'activitat educativa:
        </p>
      </div>
    </div>

    <div className="row">
      <div className="col col-12 ">
        <FormSelectYesNo
          id="authMaterialExposat"
          name="authMaterialExposat"
          col="col-4"
          label="Autoritzo"
          obligatori={true}
          value={authMaterialExposat}
          handleChange={(e) => handleChangeMaterialExposat(e.target.value)}
          error={errorMaterialExposat}
        />
      </div>
    </div>

    <p>
      <ol>
        <li>D’ús d’imatge del professorat i personal de l’escola sigui captada i reproduïda per l’alumne.</li>
        <li>Queda prohibida la gravació de la veu a les classes i dintre dels espais de l’escola.</li>
      </ol>
      <input type="checkbox" id="authImatgeProhibicions" name="authImatgeProhibicions" value={authImatgeProhibicions} checked={authImatgeProhibicions === "1" ? true : false} onChange={(t) => { handleChangeImatgeProhibicions(t.target.value) }} required />
      <label htmlFor="authImatgeProhibicions"> Em dono per assabentat/ada d'aquestes prohibicions</label>
      <span id="auhtMaterial_ERROR" className="a-Form-error">{errorImatgeProhibicions}</span>
    </p>
    <br />
  </>)
}
